module.exports = __webpack_public_path__ + "d8c862b31ada25ad08493fd6b1f687ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-niceidea.png
// module id = 2074
// module chunks = 4